* {
  box-sizing: border-box;
}

:host {
  position: fixed;
  display: flex;
  flex-direction: column;
  width: auto;
  height: auto;
  z-index: 9999;
  max-width: 100%;
}

:host([x='right']) {
  right: calc(var(--spacer) * 4);
}

:host([x='left']) {
  left: calc(var(--spacer) * 4);
}

:host([y='bottom']) {
  bottom: calc(var(--spacer) - 2px);
}

:host([y='top']) {
  top: calc(var(--spacer) - 2px);
}
